import { render, staticRenderFns } from "./UserMgt.vue?vue&type=template&id=637a22f2"
import script from "./UserMgt.vue?vue&type=script&lang=js"
export * from "./UserMgt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports